import React, { useEffect, useState } from "react";
import Accordion from "components/Accordion";
import WorkspacesItem from "layout/systemAdmin/workspaces/WorkspacesItem";
import WorkspacesUsersTable from "layout/systemAdmin/workspaces/WorkspacesUsersTable";
import { useSelector } from "react-redux";

const WorkspacesContentBody = () => {
  const workspacesInfo = useSelector(
    (state) => state.systemAdmin?.workspacesInfo
  );
  const searchTerm = useSelector((state) => state.systemAdmin.searchTerm);
  const redirectedWorkspace = useSelector(
    (state) => state.systemAdmin.redirectedWorkspace
  );
  const [display, setDisplay] = useState(workspacesInfo);

  useEffect(() => {
    const filtered = {
      ...workspacesInfo,
      workspaces: workspacesInfo?.workspaces
        // Filter first user match
        .map((workspace) => ({
          ...workspace,
          users: workspace.users.filter(
            (user) =>
              user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              user.username.toLowerCase().includes(searchTerm.toLowerCase())
          ),
        }))
        // Then workspace that match or has users that match
        .filter(
          (workspace) =>
            workspace.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            workspace.users.length
        )
        // If workspace match show all users not just those that match
        .map((workspace) =>
          workspace.name.toLowerCase().includes(searchTerm.toLowerCase())
            ? {
                ...workspace,
                users: workspacesInfo.workspaces.find(
                  (ws) => ws.name === workspace.name
                ).users,
              }
            : { ...workspace }
        ),
    };

    setDisplay(filtered);
  }, [searchTerm, workspacesInfo]);

  useEffect(() => {
    const expanded = document.getElementsByClassName("accordion active")[0];
    const scrollDiv = document.getElementsByClassName(
      "system_admin__container"
    )[0];
    const topPos = expanded?.offsetTop;
    if (redirectedWorkspace && scrollDiv) {
      scrollDiv.scrollTop = topPos;
    }
  }, [redirectedWorkspace]);

  return display?.workspaces?.map((workspaceItem) => {
    const licensedUsers = workspaceItem.users.filter((u) => u.licensed).length;
    const reservedLicenses =
      workspaceItem.reservedLicenses !== -1
        ? workspaceItem.reservedLicenses
        : null;
    return (
      <Accordion
        header={
          <WorkspacesItem
            workspaceId={workspaceItem.id}
            workspaceName={workspaceItem.name}
            licensedUsers={licensedUsers}
            nonLicensedUsers={workspaceItem.users.length - licensedUsers}
            reservedLicenses={reservedLicenses}
            bannerProperties={workspaceItem.bannerProperties}
          />
        }
        panel={
          <WorkspacesUsersTable
            users={workspaceItem.users}
            workspaceId={workspaceItem.id}
            workspaceName={workspaceItem.name}
          />
        }
        expanded={
          searchTerm !== "" || workspaceItem.name === redirectedWorkspace
        }
      />
    );
  });
};

export default WorkspacesContentBody;
